import React from "react";
import { useNavigate } from "react-router-dom";

const FastSearch = ({info}) => {
  const searchItem = [
    {
      id:1,
      title:'خانه روستایی'
    },
    {
      id:1,
      title:'اقامتگاه مشهد '
    },
    {
      id:1,
      title:'ویلا رامسر '
    },
    {
      id:1,
      title:'بومگردی اصفهان '
    },
    {
      id:1,
      title:'ویلا اطراف تهران '
    },
    {
      id:1,
      title:'کلبه جنگلی '
    },
    {
      id:1,
      title:'ویلا ییلاقی '
    },
    {
      id:1,
      title:'ویلا استخردار '
    },
    {
      id:1,
      title:'بوم گردی ماسال '
    },
    {
      id:1,
      title:'ویلا باغ دزفول '
    },
    {
      id:1,
      title:'هتل آرپاتمان مشهد '
    },
    {
      id:1,
      title:'ویلا سـاحلی مــحـمـود آبـاد '
    },
    {
      id:1,
      title:'سوئیت کاشان '
    },
    {
      id:1,
      title:'ویلا تالش '
    },
    {
      id:1,
      title:'هتل آپارتمان متل قو '
    },
    {
      id:1,
      title:'سوئیت کیش '
    },
    {
      id:1,
      title:'سوئیت قشم '
    },
  ]
  const navigate = useNavigate()
  return (
    <div className="container">
      <div>
        <h4 className="font-[700] text-[40px] text-[#292D32]">
          جست و جوی سریع
        </h4>
        <div className="text-[20px] mt-[10px]  text-[#797D82]">
        بهترین اقامتگاه ها را با مناسب ترین قیمت ها و  امکانات رزرو کنید 
        </div>
      </div>
     <div className="fastsearch-container">
       {
         info?.map(i=><div  onClick={()=>window.location.replace(i.link)} className="fastsearch-box cursor-pointer">{i.title}</div>)
       }
     </div>
    </div>
  );
};

export default FastSearch;
